import { onBeforeUnmount, reactive } from 'vue'
import { enterpriseProfileApi, marketAnalysisApi, materialAssetsApi, projectWorkspaceApi } from '@/api/index.js'
import { projectReads } from '@/api/projectReads.js'
import { projectScope } from '@/utils/projectRefresh.js'
import { useProjectRefresh } from './useProjectRefresh.js'

export function shanghaiToday() {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Shanghai', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date())
}

export function useProjectBrain({ tenantId, projectId }) {
  const data = reactive({}), states = reactive({})
  const reads = projectReads({
    profile: signal => enterpriseProfileApi.get(tenantId, projectId, { signal }),
    run: signal => marketAnalysisApi.current(tenantId, projectId, { signal, compact: true }),
    history: signal => marketAnalysisApi.history(tenantId, projectId, { signal, compact: true }),
    materials: () => materialAssetsApi.list(tenantId, projectId),
    persona: () => projectWorkspaceApi.currentPersonaBatch(tenantId, projectId),
    progress: () => projectWorkspaceApi.personaGenerationProgress(tenantId, projectId),
    assignments: () => projectWorkspaceApi.personaAssignments(tenantId, projectId),
    policy: () => projectWorkspaceApi.dailyDispatchPolicy(tenantId, projectId),
    today: async () => {
      const day = shanghaiToday()
      return projectWorkspaceApi.dailyTaskOverview(tenantId, projectId, day, '', { allBatches: true })
    },
  }, data, states)
  useProjectRefresh(projectScope(tenantId, projectId), reads.load)
  onBeforeUnmount(reads.stop)
  return { data, states, load: () => reads.load({ force: true }) }
}
